module.exports = __webpack_public_path__ + "img/IMG_1962.58365a47.jpg";